(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('loadingSpinner', ['$rootScope', function ($rootScope) {

            var template = [
                '<div class="prints center" class="anz-loading" ng-if="loading.loading">',
                '    <div class="prints-frame">',
                '        <div class="foot-prints">',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '            <div class="prints-foot"></div>',
                '        </div>',
                '        <h2 role="alertdialog" aria-busy="true" aria-live="assertive">{{loading.status}}...</h2>',
                '    </div>',
                '</div>'
            ];

            return {
                restrict: 'E',
                replace: true,
                template: template.join('')
            };
        }])

        .directive('buttonSpinner', ['$rootScope', function ($rootScope) {

            var template = [
                '<div class="spinner-container">',
                '   <div class="spinner center" ng-if="loading">',
                '   <div class="hide" role="alert" aria-live="assertive">Fetching...</div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '       <div class="spinner-blade"></div>',
                '   </div>',
                '   <div ng-if="!loading">',
                '       <ng-transclude></ng-transclude>',
                '   </div>',
                '</div>'
            ];

            return {
                restrict: 'E',
                replace: true,
                scope: {
                    loading: "="
                },
                template: template.join(''),
                transclude: true
            };
        }]);

})(window, window.angular);